import * as React from 'react';
export const konbiniSeicomartSvg = React.forwardRef(
  function konbiniSeicomartSvgInner(props, ref) {
    return /*#__PURE__*/ React.createElement(
      'svg',
      {
        ...props,
        ref: ref,
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F08300',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M32 25.986v.776c-8.188 4.675-16.038 1.547-16.038 1.547-8.087-3.055-7.157-9.875-6.649-13.609.098-.716.18-1.319.18-1.76-.032-.934-.388-1.417-.711-1.74a8.432 8.432 0 0 0-.249-.233c-.285-.26-.577-.528-.527-.701.097-.226 1.002-.258 1.81-.193.534.07.95.16 1.308.238.293.064.547.12.795.148.373.07.83.04 1.166.017.13-.01.24-.017.321-.017h.065v.097c-2.813 3.318-1.39 6.83.97 7.797.453.161 2.879.966 4.205-2.256.352-.877.49-1.723.63-2.58.143-.874.288-1.76.663-2.703 2.07-5.123 7.083-5.896 9.703-5.316 1.263.267.584.535.373.618-.043.017-.066.026-.05.026 0 0-1.293.29-1.94 1.804-.616 1.534-.411 2.79-.198 4.095.234 1.437.478 2.934-.352 4.927-1.326 3.286-4.43 3.705-4.43 3.705-.162.032-.26.193-.26.354.033.097.13.193.26.193 3.75.451 5.303-1.095 6.241-3.286.778-1.808 1.758-2.825 2.714-3.382v7.39c-1.263 2.163-3.757 4.035-8.18 2.855h-.129c-.13.032-.226.064-.226.193v.161c.012.025.03.046.047.065.026.03.05.057.05.096 2.492 2.15 6.78 1.169 8.438.674ZM9.72 10.91c0 .194.161.355.388.355.226 0 .388-.161.388-.355 0-.225-.162-.418-.388-.418-.227 0-.388.193-.388.418Z',
        fill: '#fff',
      }),
    );
  },
);
konbiniSeicomartSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var konbiniSeicomart = {
  category: 'brand',
  colorable: false,
  name: 'konbiniSeicomart',
  svg: konbiniSeicomartSvg,
};
